import { AxiosRequestConfig } from "axios";
import merge from "lodash/merge";

import { InviteSvcInstance } from "./schemas";
import { GranularCatalogConfig } from "@granular/fabric-catalog-helpers";
import invitesResource from "./invites";

const createInviteSvcInstance = (
  catalogConfig: GranularCatalogConfig,
  instanceRequestConfig?: AxiosRequestConfig,
): InviteSvcInstance => {
  return {
    deleteInvitations: ({
      operationId,
      username,
      domain,
      axiosRequestConfig,
    }) =>
      invitesResource.deleteInvitations({
        operationId,
        username,
        catalogConfig,
        domain,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
    postInvitation: ({ invite, domain, axiosRequestConfig }) =>
      invitesResource.postInvitation({
        invite,
        domain,
        catalogConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
    postInvitations: ({ invites, domain, axiosRequestConfig }) =>
      invitesResource.postInvitations({
        invites,
        domain,
        catalogConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
    getInvitations: ({ operationId, domain, axiosRequestConfig }) =>
      invitesResource.getInvitations({
        operationId,
        domain,
        catalogConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
  };
};

export default createInviteSvcInstance;
